import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    Row,
} from "reactstrap";

import EcommerceOrdersModal from "components/Common/EcommerceOrdersModal";
import CommonTable from "../../../components/Common/TableContainer";
import JobCategoryAddEditModal from "pages/AllCommonModal/JobCategoryAddEditModal/job-category-add-edit-modal";
import { getCategoryList } from "model/CategoryModel";
import Spinners from "components/Common/Spinner";
import { getJobRequiredList, submitJobRequiredFilterData } from "model/JobRequiredModel";
import JobRequiredAddEditModal from "pages/AllCommonModal/JobRequiredAddEditModal/job-required-add-edit-modal";
import AllCommonFilterModal from "pages/AllCommonFilter/all-common-filter";
import { useJobRequiredContext } from "libs/context/JobRequiredContext";
import { pascalToCamel } from "helpers/GeneralHelper";
import { submitQuestionTypeFilterData } from "model/QuestionTypeModel";
import Loaders from "components/Common/Loaders";
import { usePermissionContext } from "libs/context/PermissionContext";

const JobCategory = () => {
    const { permissionData } = usePermissionContext() || {};
    const { fetchJobRequiredContextData, jobRequiredContextData } = useJobRequiredContext() || {};
    const [jobRequiredAddEditModalOpen, setJobRequiredAddEditModalOpen] = useState(false);
    const [modal1, setModal1] = useState(false);
    const toggleViewModal = () => setModal1(!modal1);

    const [searchTerm, setSearchTerm] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const [jobRequiredData, setJobRequiredData] = useState("");
    const [loading, setLoading] = useState(false);
    const [itemId, setItemId] = useState(null); // ✅ important
    const initialState = {
        name: "",
        forClient: 0,
        forJob: 1,
        status: true,
    };

    const [formData, setFormData] = useState(initialState);
    const [tableMetaData, setTableMetadata] = useState();
    const [commonFilterModalOpen, setCommonFilterModalOpen] = useState(false);

    const filteredData = useMemo(() => {
        if (!searchQuery?.trim()) return jobRequiredData;

        return jobRequiredData?.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [jobRequiredData]);

    const jobRequiredActionPermissions = useMemo(
        () => ({
            canCreate: Boolean(permissionData?.JobRequireAddAccess),
            canEdit: Boolean(permissionData?.JobRequireUpdateAccess),
        }),
        [permissionData]
    );

    const hasAnyJobRequiredRowAction = useMemo(
        () => jobRequiredActionPermissions.canEdit,
        [jobRequiredActionPermissions]
    );

    // ✅ FIXED: set itemId FIRST, then open modal
    const handleEdit = (row) => {
        setItemId(row?.id);
        setJobRequiredAddEditModalOpen(true);
    };

    useEffect(() => {
        fetchJobRequiredContextData()
        getJobRequired();
    }, []);

    const getJobRequired = async () => {
        setLoading(true);
        let response = await submitJobRequiredFilterData({});
        let requiredData = response?.data;
        const valueReModified = requiredData?.map(item => ({
            ...item,
            ID: item?.id,
        }));

        if (response) {
            setJobRequiredData(valueReModified);
            setLoading(false);
        } else {
            setJobRequiredData([]);
            setLoading(false);
        }
    };

    const handleFilterSubmit = async (data) => {
        setLoading(true);
        let response = await submitFilterData(data);
        let filterData = response?.data;

        if (response) {
            setJobCategoryData(filterData);
            setLoading(false);
            setCommonFilterModalOpen(false);
        } else {
            setJobCategoryData([]);
            setLoading(false);
            setCommonFilterModalOpen(false);
        }
    };
    useEffect(() => {
        const valueReModified = jobRequiredContextData?.table?.columns?.map(col => ({
            Header: col?.title,
            accessor: col?.field,
        }));
        // console.log('valueReModified', valueReModified)
        setTableMetadata(valueReModified)
    }, [jobRequiredContextData]);

    const handleSearchSubmit = async (value) => {
        setLoading(true);

        const payload = {
            search: value, // adjust key if backend expects something else
        };

        let response = await submitJobRequiredFilterData(payload);
        let searchData = response?.data;

        if (response) {
            setJobRequiredData(searchData);
        } else {
            setJobRequiredData([]);
        }

        setLoading(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />

                    {/* Table */}
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-3">Job Required</h5>


                                {jobRequiredActionPermissions.canCreate ? (
                                    <Col xs="12" md="4" className="text-md-end mt-2 mt-md-0">
                                        <Button
                                            color="primary"
                                            onClick={() => {
                                                setItemId(null);
                                                setJobRequiredAddEditModalOpen(true);
                                                setFormData(initialState);
                                            }}
                                        >
                                            + Create
                                        </Button>
                                    </Col>
                                ) : null}
                            </div>
                            <hr />

                            <Row className="align-items-center g-2 mb-4">
                                <Col xs="12" md="8">
                                    <div className="d-flex border rounded w-100 category-search-input">
                                        <Input
                                            type="text"
                                            placeholder="Search by name"
                                            className="border-0"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e?.target?.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearchSubmit(searchQuery?.trim());
                                                }
                                            }}
                                        />
                                        <Button
                                            className="search-icon-button"
                                            onClick={() => handleSearchSubmit(searchQuery?.trim())}
                                        >
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </div>
                                </Col>

                                {/* <Col xs="12" md="4" className="text-md-end mt-2 mt-md-0">
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            setItemId(null);
                                            setJobRequiredAddEditModalOpen(true);
                                            setFormData(initialState);
                                        }}
                                    >
                                        + Create
                                    </Button>
                                </Col> */}
                            </Row>
                            {/* <div className="mb-4 h4 card-title">Job Required</div> */}
                            {(!loading && jobRequiredData?.length && tableMetaData?.length) ? (
                                <CommonTable
                                    columns={tableMetaData}
                                    data={filteredData}
                                    isActionRequired={hasAnyJobRequiredRowAction}
                                    onEdit={
                                        jobRequiredActionPermissions.canEdit ? handleEdit : undefined
                                    }
                                    isEditAccess={jobRequiredActionPermissions.canEdit}
                                    isCheckboxLeftSide={false}
                                    isPagination={false}
                                    setCommonFilterModalOpen={setCommonFilterModalOpen}
                                    pageName={"Job Required"}
                                />
                            ) :
                                // <Card className="border mb-3">
                                //     <CardBody>
                                //         <Spinners setLoading={setLoading} />
                                //     </CardBody>
                                // </Card>
                                <Loaders />
                            }
                        </CardBody>
                    </Card>

                    {/* Add/Edit Modal */}
                    <JobRequiredAddEditModal
                        setJobRequiredAddEditModalOpen={setJobRequiredAddEditModalOpen}
                        jobRequiredAddEditModalOpen={jobRequiredAddEditModalOpen}
                        getJobRequiredList={getJobRequired}
                        itemId={itemId}
                        setItemId={setItemId}
                        setJobRequiredData={setJobRequiredData}
                        setFormData={setFormData}
                        formData={formData}
                        initialFormState={initialState}
                    />

                    <AllCommonFilterModal
                        setCommonFilterModalOpen={setCommonFilterModalOpen}
                        commonFilterModalOpen={commonFilterModalOpen}
                        modalTitle="Job Required"
                        handleSubmit={handleFilterSubmit}
                        filterData={jobRequiredContextData?.filters}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

JobCategory.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(JobCategory);
